module.exports = __webpack_public_path__ + "static/media/18pic.5da3bbbe.jpg";